import React, { useEffect, useState } from "react";
import { Modal, Box, Tabs, Tab, Checkbox, Button } from "@mui/material";
import ModalHeaderStyle from "../utility/component/styles/modalHeader";
import { GetListItemMaster } from "./function";
import { useDispatch, useSelector } from "react-redux";
import { selectPrefix } from "../utility/Redux/profile";
import { selectToken } from "../utility/Redux/security";

const mockItems = [
  {
    id: 1,
    name: "Chips Packet",
    price: 20,
    image: "https://via.placeholder.com/60?text=Chips",
  },
  {
    id: 2,
    name: "Cola Drink",
    price: 40,
    image: "https://via.placeholder.com/60?text=Cola",
  },
  {
    id: 3,
    name: "Noodles",
    price: 35,
    image: "https://via.placeholder.com/60?text=Noodles",
  },
  {
    id: 4,
    name: "Chocolate",
    price: 25,
    image: "https://via.placeholder.com/60?text=Choco",
  },
  {
    id: 5,
    name: "Biscuit",
    price: 15,
    image: "https://via.placeholder.com/60?text=Biscuit",
  },
];

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "90%",
  maxWidth: 600,
  bgcolor: "background.paper",
  boxShadow: 24,
  borderRadius: "12px",
  border: "0px solid black",
  outline: "none",
};

export default function ItemSelectModal({
  open,
  onClose,
  itemSearchText,
  onSubmit,
  accountdetails,
}) {
  const [tab, setTab] = useState(0);
  const [search, setSearch] = useState("");
  const [selectedItems, setSelectedItems] = useState([]);
  const [itemList, setItemList] = useState([]);
  const handleToggle = (item) => {
    setSelectedItems((prev) =>
      prev.some((i) => i.ICODE === item.ICODE)
        ? prev.filter((i) => i.ICODE !== item.ICODE)
        : [...prev, item]
    );
  };

  const handleSubmit = () => {
    onSubmit(selectedItems);
    setSelectedItems([]);
    onClose();
  };

  const prefix = useSelector(selectPrefix);
  const token = useSelector(selectToken);
  const dispatch = useDispatch();
  useEffect(() => {
    if (open) {
      setSelectedItems([]);
      setSearch(itemSearchText);
      GetListItemMaster(
        prefix,
        "",
        token,
        dispatch,
        "",
        "",
        setItemList,
        "",
        () => {},
        accountdetails,
        "",
        itemSearchText
      );
    }
  }, [open]);

  return (
    <Modal open={open} onClose={onClose}>
      <Box sx={style}>
        <ModalHeaderStyle onClose={onClose} header={"Search Items"} />
        <div className="p-2">
          <Tabs value={tab} onChange={(_, val) => setTab(val)} sx={{ mb: 2 }}>
            <Tab label="All Items" />
            <Tab label={`Selected (${selectedItems.length})`} />
          </Tabs>

          {tab === 0 && (
            <div className="space-y-2  min-h-[408px]">
              <div className="flex w-full  border overflow-hidden border-gray-300 rounded mb-2">
                <input
                  type="text"
                  placeholder="Search items..."
                  value={search}
                  onKeyDown={(e) => {
                    if (e.code === "Enter" || e.code === "NumpadEnter") {
                      GetListItemMaster(
                        prefix,
                        "",
                        token,
                        dispatch,
                        "",
                        "",
                        setItemList,
                        "",
                        () => {},
                        accountdetails,
                        "",
                        e.target.value
                      );
                    }
                  }}
                  onChange={(e) => setSearch(e.target.value)}
                  className=" outline-none flex flex-1 p-2"
                />
                <button
                  onClick={() => {
                    GetListItemMaster(
                      prefix,
                      "",
                      token,
                      dispatch,
                      "",
                      "",
                      setItemList,
                      "",
                      () => {},
                      accountdetails,
                      "",
                      search
                    );
                  }}
                  className="bg-brown"
                >
                  <i className="bi bi-search  text-white  flex items-center px-3 " />
                </button>
              </div>
              <div className="overflow-y-auto max-h-[350px] h-fit grid grid-cols-2 gap-2">
                {itemList.map((item) => (
                  <div
                    key={item.id}
                    className="flex items-center h-fit justify-between border rounded p-2 hover:shadow transition"
                  >
                    <div className="flex items-center gap-3">
                      <div>
                        <div className="font-medium">{item.ITEMNAME}</div>
                        <div className="text-sm text-gray-600">
                          ₹{item.PUR_PRICE}
                        </div>
                      </div>
                    </div>
                    <Checkbox
                      checked={selectedItems.some(
                        (i) => i.ICODE === item.ICODE
                      )}
                      onChange={() => handleToggle(item)}
                    />
                  </div>
                ))}
              </div>
            </div>
          )}

          {tab === 1 && (
            <div className="space-y-2 max-h-[350px] min-h-[408px] overflow-y-auto">
              {selectedItems.length === 0 ? (
                <p className="text-center text-gray-500">
                  No items selected yet 👀
                </p>
              ) : (
                selectedItems.map((item) => (
                  <div
                    key={item.id}
                    className="flex items-center justify-between border rounded p-2"
                  >
                    <div className="flex items-center gap-3">
                      <div>
                        <div className="font-medium">{item.ITEMNAME}</div>
                        <div className="text-sm text-gray-600">
                          ₹{item.PUR_PRICE}
                        </div>
                      </div>
                    </div>
                    <Button
                      color="error"
                      size="small"
                      onClick={() => handleToggle(item)}
                    >
                      Remove
                    </Button>
                  </div>
                ))
              )}
            </div>
          )}

          <div className="flex justify-end mt-4 gap-2">
            <Button onClick={onClose}>Cancel</Button>
            <Button
              onClick={handleSubmit}
              variant="contained"
              disabled={selectedItems.length === 0}
            >
              Add to Bill Cart
            </Button>
          </div>
        </div>
      </Box>
    </Modal>
  );
}
